export default __webpack_public_path__ + "static/media/xls.a8d56d2a.svg";